var map = {
	"./1.avif": 6096,
	"./2.avif": 7077,
	"./3.avif": 2022,
	"./4.avif": 107,
	"./5.avif": 4428,
	"./6.avif": 2913,
	"./7.avif": 7458,
	"./8.avif": 4775
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6189;